const BASE_URL = "https://srv709257.hstgr.cloud:444/api/v1";

export default BASE_URL;